import {ValidatorFn, Validators} from '@angular/forms';
import {ControlBuilder} from '../../dynamic-field/control-builder.type';
import {buildAsyncValidators, buildDefaultValidators} from '../../dynamic-field/default-control-builder';
import {CheckboxFieldConfig} from './checkbox-field.config';

export const checkboxFieldControlBuilder: ControlBuilder = (fieldConfig: CheckboxFieldConfig, formBuilder) => {

    const {disabled, value} = fieldConfig;

    const validators = buildDefaultValidators(fieldConfig);
    const asyncValidators = buildAsyncValidators(fieldConfig);
    return formBuilder.control(
        {
            disabled,
            value: value || false,
        },
        validators,
        asyncValidators
    );
};
export const buildCheckboxFieldValidators: (fieldConfig: CheckboxFieldConfig) => ValidatorFn[] =
    (config): ValidatorFn[] => {
        const validators = buildDefaultValidators(config);
        if (config.required) {
            validators.push(Validators.required);
        }
        return validators;
    };
